module.exports = __webpack_public_path__ + "static/media/3.8178463b.jpeg";